module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/receipt-0fe5e774ef07bd40f402752303dfc0d9.png";